import React from 'react';
import './index.css';

const NotFound = () => {
  return (
    <div className="not-found-page">
      <div className="stars-bg"></div>
      
      <div className="container">
        <div className="not-found-content">
          <div className="error-code">
            <span className="code-digit">4</span>
            <span className="code-star">★</span>
            <span className="code-digit">4</span>
          </div>
          
          <h1 className="error-title">页面不见了</h1>
          
          <p className="error-description">
            你寻找的页面可能已经消失在星空中，
            或者还没有被创造出来。
          </p>
          
          <div className="error-actions">
            <a href="/" className="home-btn purple-btn">
              🏠 返回首页
            </a>
            <a href="/archive" className="archive-btn">
              📚 查看文章
            </a>
          </div>
          
          <div className="floating-astronaut">
            <div className="astronaut">👨‍🚀</div>
            <div className="floating-text">寻找丢失的页面...</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;